import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum StoreKey {
  /**
   * BottomNavComponentの選択状態
   */
  I = '_selectedId',
}

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  navChange: Subject<number> = new Subject<number>();
  nav$ = this.navChange.asObservable();

  constructor() { }

  /**
   * フッターの選択状態を変更する
   */
  changeBottomNav(id: number): void {
    this.navChange.next(id);
  }

  /**
   * sessionStorage中にComponent関連の状態を保存する
   */
  set(key: string, value: any): void {
    sessionStorage.setItem(key, value);
  }

  /**
   * sessionStorage中にComponent関連の状態を取得する
   */
  get(key: string): any {
    return sessionStorage.getItem(key) || '';
  }

  /**
   * sessionStorage中の値をクリアする
   */
  remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  /**
   * sessionStorage中の値を全てクリアする
   */
  clearAll(): void {
    Object.entries(StoreKey).forEach(([key, value]) => {
      sessionStorage.removeItem(value);
    })
  }

}
